export default "__VITE_ASSET__Ca2iZsJ8__"